var scope_0 = require('/home/lyp/projects/cj/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/da33e3d4402aab623cf9c5b73ad669f2.js').default;
var scope_1 = require('/home/lyp/projects/cj/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd88a608acb83638cfe5ea88da3dc846.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    